import React, {useMemo} from 'react';
import _ from 'lodash';
import {Dropdown} from 'react-bootstrap';
import relationIcon from '^assets/images/relation.svg';
import {TableIcon} from '^common/tableIcon';

const DropdownToggle = React.forwardRef((
    props,
    ref,
) => {
    return <TableIcon
        ref={ref}
        className={'mx-2'}
        src={relationIcon}
        alt={'External Links'}
        {...props}
    />;
});

const DropdownLinks = ({
    title,
    links,
}) => {
    const categories = useMemo(
        () => _.chain(links)
            .map('category')
            .uniq()
            .value(),
        [links],
    );

    return <>
        <Dropdown.Header className={'fw-bold px-2 py-0'}>
            {title}
        </Dropdown.Header>
        {_.map(categories, (category, idxC) => <>
            <Dropdown.Header
                key={idxC}
                className={'px-2 py-0'}
            >
                {category}
            </Dropdown.Header>
            {_.map(
                _.filter(links, {category}),
                (link, idxL) => <Dropdown.Item
                    key={idxL}
                    className={'ps-4'}
                    onClick={() => window.open(
                        link.url,
                        '_blank',
                        'noreferrer',
                    )}
                >
                    {link.label}
                </Dropdown.Item>,
            )}
        </>)}
    </>;
};

const WorkTicketExternalLinks = ({
    workTicket,
}) => {
    const hasFtmLinks = useMemo(
        () => _.size(_.concat(workTicket?.ftm_links)) > 0,
        [workTicket],
    );

    const hasNiagaraLinks = useMemo(
        () => _.size(_.concat(workTicket?.niagara_links)) > 0,
        [workTicket],
    );

    if (!hasFtmLinks && !hasNiagaraLinks) return null;

    return <Dropdown>
        <Dropdown.Toggle as={DropdownToggle}/>
        <Dropdown.Menu>
            {hasFtmLinks && <DropdownLinks
                title={'FTM'}
                links={workTicket?.ftm_links}
            />}
            {hasFtmLinks && hasNiagaraLinks && <Dropdown.Divider/>}
            {hasNiagaraLinks && <DropdownLinks
                title={'Niagara'}
                links={workTicket?.niagara_links}
            />}
        </Dropdown.Menu>
    </Dropdown>;
};

export default WorkTicketExternalLinks;
